import React from 'react';

const GIF = (props) => (
    <svg
        width="22px"
        height="19px"
        viewBox="0 0 22 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/GIF b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -1356.000000)" fill="#000000">
                <g id="Icon/OL-Copy-5" transform="translate(386.000000, 1356.000000)">
                    <path
                        d="M16.4884926,14.875 C17.5240265,14.875 18.3634926,15.7144661 18.3634926,16.75 C18.3634926,17.7855339 17.5240265,18.625 16.4884926,18.625 C15.4529587,18.625 14.6134926,17.7855339 14.6134926,16.75 C14.6134926,15.7144661 15.4529587,14.875 16.4884926,14.875 Z M7.48849258,14.875 C8.52402649,14.875 9.36349258,15.7144661 9.36349258,16.75 C9.36349258,17.7855339 8.52402649,18.625 7.48849258,18.625 C6.45295867,18.625 5.61349258,17.7855339 5.61349258,16.75 C5.61349258,15.7144661 6.45295867,14.875 7.48849258,14.875 Z M4.25,0.625 C4.62969577,0.625 4.94349096,0.907153882 4.99315338,1.27322944 L5,1.375 L5,3.625 L20.75,3.625 C21.1296958,3.625 21.443491,3.90715388 21.4931534,4.27322944 L21.5,4.375 L21.5,13.375 C21.5,13.7546958 21.2178461,14.068491 20.8517706,14.1181534 L20.75,14.125 L4.25,14.125 C3.87030423,14.125 3.55650904,13.8428461 3.50684662,13.4767706 L3.5,13.375 L3.5,2.125 L1.25,2.125 C0.870304234,2.125 0.556509039,1.84284612 0.506846616,1.47677056 L0.5,1.375 C0.5,0.995304234 0.782153882,0.681509039 1.14822944,0.631846616 L1.25,0.625 L4.25,0.625 Z M20,5.125 L5,5.125 L5,12.625 L20,12.625 L20,5.125 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default GIF;
